import {combineReducers} from 'redux';
import events from './events/reducer';
import general from './general/reducer';
import permissions from './permissions/reducer';
import tournamentList from './tournamentList/reducer';
import squads from './squads/reducer';
import divisions from './divisions/reducer';
import capacity from './capacity/reducer';
import status from './status/reducer';
import fees from './fees/reducer';
import bundling from './restrictions/bundles/reducer';
import restrictions from './restrictions/reducer';
import {SET_TOURNAMENT_FOR_SETUP} from './constants';

const initialState = {
  tournamentInfo: {}
};

const base = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_TOURNAMENT_FOR_SETUP:
      return {
        ...state,
        tournamentInfo: payload || initialState.tournamentInfo
      };
    default:
      return state;
  }
};

export default combineReducers({
  base,
  events,
  general,
  permissions,
  tournamentList,
  squads,
  divisions,
  capacity,
  status,
  fees,
  bundling,
  restrictions
});



// WEBPACK FOOTER //
// ./src/features/tournament/reducer.js